var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubnavSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.727 17.293l-3.895-3.895a.937.937 0 00-.664-.273h-.637a8.085 8.085 0 001.719-5A8.124 8.124 0 008.125 0 8.124 8.124 0 000 8.125a8.124 8.124 0 008.125 8.125c1.887 0 3.621-.64 5-1.719v.637c0 .25.098.488.273.664l3.895 3.895a.934.934 0 001.324 0l1.106-1.106a.942.942 0 00.004-1.328zM8.125 13.125c-2.762 0-5-2.234-5-5 0-2.762 2.234-5 5-5 2.762 0 5 2.234 5 5 0 2.762-2.234 5-5 5z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubnavSearch);
export default ForwardRef;